import React from 'react';
import styles from './Label.module.scss';
import classNames from 'classnames';

type PropsType = {
    children: React.ReactNode;
    className?: string;
};

const Label = (props: PropsType) => {
    return (
        <label className={classNames(styles.label, props.className)}>
            {props.children}
        </label>
    );
};

export default Label;
